<template>
  <base-slide-over ref="approveWithChangesSlideover" title="Refill Approval" size="5xl" style="z-index: 10000">
    <base-content>
      <div v-if="isLoading" class="tw-flex tw-justify-center tw-py-5">
        <base-spinner />
      </div>
      <edit-business-member-prescription-medications
        :allowed-medications="allowedMedications"
        :max-medications="prescription.businessProgram ? prescription.businessProgram.maxMedications : 0"
        :edit-medications.sync="editMedications"
        hide-save
        v-else
      />
      <inline-error id="approve-changes-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-content>
    <template #fixed-bottom>
      <div class="tw-p-3 tw-flex tw-justify-end">
        <base-button type="flat" class="tw-w-auto tw-mr-2" @click="hide()">
          Cancel
        </base-button>
        <base-button class="tw-w-auto" @click="approveRxAuth" :loading="isSaving"> Approve{{ changesMade ? " with Changes" : "" }} </base-button>
      </div>
    </template>
  </base-slide-over>
</template>

<script>
import EditBusinessMemberPrescriptionMedications from "@/views/business/member/prescriptions/components/EditBusinessMemberPrescriptionMedications";
import InlineError from "@/components/InlineError";
import { orderBy } from "lodash";
import { mapGetters } from "vuex";

export default {
  name: "ApproveRxAuthWithChanges",
  components: {
    EditBusinessMemberPrescriptionMedications,
    InlineError,
  },
  props: {
    businessId: String,
  },
  data() {
    return {
      isLoading: false,
      isSaving: false,
      todoItemId: null,
      userId: null,
      businessPrescriptionId: null,
      prescription: {},
      editMedications: [],
      originalMedications: [],
      errorTitle: "",
      errorMessage: "",
      error: null,
      currentComponent: null,
    };
  },
  computed: {
    ...mapGetters("location", ["location", "locations"]),
    allowedMedications() {
      return this.prescription.businessProgram
        ? this.prescription.businessProgram.allowedMedications
            .map((am) => ({
              label: am.name.value,
              value: am.id,
              productGroup: am.productGroup,
            }))
            .filter((m) => !this.editMedications.find((em) => em.value === m.value))
        : [];
    },
    changesMade() {
      const newMedications = this.editMedications.map((m) => m.value).filter((m) => m);
      return this.originalMedications.length !== newMedications.length || this.originalMedications.some((m, i) => m !== newMedications[i]);
    },
  },
  methods: {
    show(todoItemId, userId, businessPrescriptionId) {
      this.todoItemId = todoItemId;
      this.userId = userId;
      this.businessPrescriptionId = businessPrescriptionId;
      this.$refs.approveWithChangesSlideover.show();
      this.currentComponent = "BusinessMemberPrescriptions";
      this.getPrescription();
    },
    hide() {
      this.reset();
      this.$refs.approveWithChangesSlideover.hide();
    },
    reset() {
      this.todoItemId = null;
      this.userId = null;
    },
    async getPrescription() {
      try {
        this.isLoading = true;
        const response = await this.$axios.get(`/businesses/${this.businessId}/prescriptions/${this.businessPrescriptionId}`);
        this.prescription = response.data.prescription;
        this.editMedications = orderBy(this.prescription.medications, ["sortOrder"]).map((m) => ({
          label: m.businessItemCategory.name.value,
          value: m.businessItemCategory.id,
          productGroup: m.businessItemCategory.productGroup,
        }));
        this.originalMedications = this.editMedications.map((m) => m.value).filter((m) => m);
      } finally {
        this.isLoading = false;
      }
    },
    approveRxAuth() {
      this.isSaving = true;

      this.$axios
        .post(`/businesses/${this.businessId}/todo/${this.todoItemId}/approve?isWithChanges=${this.changesMade ? "true" : "false"}`, {
          businessItemCategoryIds: this.editMedications.map((m) => m.value).filter((m) => m),
        })
        .then(() => {
          this.EventBus.$emit("GLOBAL_NOTIFY", {
            title: "Authorization Approved",
            message: `Your approval was submitted. Thank you.`,
          });
          this.EventBus.$emit("activitiesUpdated");
          this.hide();
        })
        .catch((err) => {
          this.errorTitle = `Error submitting approval`;
          this.errorMessage = "Sorry, we had trouble submitting this approval. The technicians have been notified. Please try again.";
          this.error = err;
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
  },
};
</script>
